import { v4 as uuidv4 } from 'uuid';

export function createEventGroupId(prefix = 'interaction') {
  return `${prefix}-${uuidv4()}`;
}
